import {inject, Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {catchError, combineLatest, Observable, of, switchMap} from 'rxjs';
import {Permission} from './enums/permissions.enum';
import {HOME, WELCOME} from './shared/constants';
import {UserService} from './shared/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate, CanActivateChild {
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkPermissions(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkPermissions(route);
  }

  private checkPermissions(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredPermissions = (route.data['permissions'] as Permission[]) ?? [];

    return combineLatest([
      this.userService.getCurrentUser(),
      this.userService.hasAnyPermission$(requiredPermissions),
    ]).pipe(
      switchMap(([user, hasUserPermissions]) => {
        if (!user) {
          return this.navigateAndReject(WELCOME);
        }
        if (!hasUserPermissions) {
          return this.navigateAndReject(HOME);
        }
        return of(true);
      }),
      catchError(() => this.navigateAndReject(HOME)),
    );
  }

  private navigateAndReject(route: string): Observable<boolean> {
    this.router.navigate([route]);
    return of(false);
  }
}
